import React from "react";
import { Wrench } from "@phosphor-icons/react";
import { GovPageShell, GovCard, useGovNav } from "@/components/governance/GovShell";

// Milestone placeholder for governance sections not yet implemented. Renders a
// real breadcrumb + title so navigation is fully wired and reviewable; the
// section's data views ship in the next milestone.
export const GovPlaceholder = ({ meta, section }) => {
  const navigate = useGovNav();
  return (
    <GovPageShell crumbs={meta.crumbs} title={meta.title} subtitle="Cardano on-chain governance">
      <GovCard className="flex flex-col items-center text-center gap-4 py-14">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-primary/20 bg-primary/5 text-primary">
          <Wrench size={22} />
        </span>
        <div className="space-y-1.5">
          <div className="text-[15px] font-medium text-foreground">{section || meta.title} — coming next</div>
          <p className="text-[13px] text-muted-foreground mono max-w-md">
            This governance section is confirmed and wired into navigation. Its live data views arrive in the next delivery milestone.
          </p>
        </div>
        <button
          type="button"
          data-testid="gov-placeholder-back"
          onClick={() => navigate("/governance")}
          className="inline-flex items-center gap-1.5 border border-primary/40 bg-primary/10 text-primary px-4 py-2 rounded-lg text-[11px] uppercase tracking-[0.18em] mono hover:bg-primary/20 transition-colors"
        >
          Back to overview
        </button>
      </GovCard>
    </GovPageShell>
  );
};
